<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Assign Part Number</p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <v-form 
          class="modal-card-body" 
          :valid.sync="valid">
          <div class="field">
            <label class="label">Part Number*</label>
            <v-text-field 
              required
              placeholder="Enter Part Number"
              :value="partNumber"
              @input="$emit('update:partNumber', $event)">
            </v-text-field>
          </div>
        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="addPart()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close()">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'

export default {
  components: { VForm, VTextField },
  props: {
    value: {
      type: Boolean
    },
    partNumber: {
      type: [String, Number]
    }
  },
  data() {
    return {
      valid: false
    }
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    addPart() {
      this.$emit('add-part', this.partNumber);
    }
  }
}
</script>


<style scoped>
</style>